export default __webpack_public_path__ + "static/media/group-1.152bd708.png";